// extracted by mini-css-extract-plugin
export default {"addToCartControl":"v0-z","giftCard":"w0-z","btnContainer":"x0-z","cartButton":"y0-z","disabled":"z0-z"};